import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import {isActiveToken} from '../mixins/auth';
import Login from "../views/Login/Login";
import Home from "../views/Home/Index";
import ServerInfo from "../views/Server/Info.vue";
import cfg from '../store/config';


Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  const role = store.getters['user/getRole'];
  if (role && to.meta && to.meta.access) {
    const defaultRoute = '/info';
    if (!to.meta.access.includes(role)) {
      next(defaultRoute);
      return;
    }
  }
  if (isActiveToken(store.getters['user/getToken'])) {
    next();
    return;
  }
  next('/login');
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      beforeEnter: ifAuthenticated,
      component: Home,
      children: [
        {
          path: '',
          beforeEnter: ifAuthenticated,
          component: ServerInfo,
          meta: {
            access: ['admin', 'superadmin'],
            title: 'Заявки',
          }
        },
        {
          path: 'info',
          name: 'ServerInfo',
          beforeEnter: ifAuthenticated,
          component: ServerInfo,
          meta: {
            access: ['admin', 'superadmin'],
            title: 'Заявки',
          }
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Авторизация',
      }
    },
  ],
});


let DEFAULT_TITLE = cfg.sitePrefix || '';
if (DEFAULT_TITLE) {
  DEFAULT_TITLE += ' - ';
}
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = `${DEFAULT_TITLE}${to.meta.title}`;
    } else {
      if (DEFAULT_TITLE) {
        document.title = DEFAULT_TITLE;
      } else {
        document.title = 'Frontend';
      }
    }
  });
});

export default router;
